<h2 mat-dialog-title>{{ 'AUTOBALANCE.TITLE' | translate }}</h2>

<mat-dialog-content class="autobalance-content">
    <table mat-table [dataSource]="autoBalanceData" class="autobalance-table mat-elevation-z2">
        <ng-container matColumnDef="player1">
            <th mat-header-cell *matHeaderCellDef>{{ 'AUTOBALANCE.PLAYER1' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                <div class="player-cell">
                    <img [attr.src]="row.player1.id | avatarUrl" [attr.alt]="row.player1.displayName" class="player-avatar" />
                    <span>{{ row.player1.displayName }}</span>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="player2">
            <th mat-header-cell *matHeaderCellDef>{{ 'AUTOBALANCE.PLAYER2' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                <div class="player-cell">
                    <img [attr.src]="row.player2.id | avatarUrl" [attr.alt]="row.player2.displayName" class="player-avatar" />
                    <span>{{ row.player2.displayName }}</span>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="withMatchCount">
            <th mat-header-cell *matHeaderCellDef class="count-col">{{ 'AUTOBALANCE.TOGETHER' | translate }}</th>
            <td mat-cell *matCellDef="let row" class="count-col">{{ row.withMatchCount }}</td>
        </ng-container>

        <ng-container matColumnDef="againstMatchCount">
            <th mat-header-cell *matHeaderCellDef class="count-col">{{ 'AUTOBALANCE.AGAINST' | translate }}</th>
            <td mat-cell *matCellDef="let row" class="count-col">{{ row.againstMatchCount }}</td>
        </ng-container>

        <ng-container matColumnDef="diff">
            <th mat-header-cell *matHeaderCellDef class="count-col">{{ 'AUTOBALANCE.DIFF' | translate }}</th>
            <td mat-cell *matCellDef="let row" class="count-col">{{ row.diff }}</td>
        </ng-container>

        <ng-container matColumnDef="ratio">
            <th mat-header-cell *matHeaderCellDef class="count-col">{{ 'AUTOBALANCE.RATIO' | translate }}</th>
            <td mat-cell *matCellDef="let row" class="count-col">{{ row.ratio | number: '1.2-2' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</mat-dialog-content>

<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ 'COMMON.CLOSE' | translate }}</button>
</div>
